/* 🤖 this file was generated by svg-to-ts */
export const siriusFlagDaDk: {
  name: 'flag_da_dk';
  data: string;
} = {
  name: 'flag_da_dk',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 24" style="display: block;"><g clip-path="url(#a)"><path fill="#C8102E" d="M0 0h32v24H0V0Z"/><path fill="#fff" d="M10 0h5v24h-5V0ZM0 9.5h32v5H0v-5Z"/></g><rect width="31" height="23" x=".5" y=".5" stroke="#000" stroke-opacity=".2" rx="2.5"/><defs><clipPath id="a"><rect width="32" height="24" fill="#fff" rx="3"/></clipPath></defs></svg>`
};
